import { render, staticRenderFns } from "./ProjectPoint.vue?vue&type=template&id=278caa28&scoped=true&"
import script from "./ProjectPoint.vue?vue&type=script&lang=js&"
export * from "./ProjectPoint.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPoint.vue?vue&type=style&index=0&id=278caa28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278caa28",
  null
  
)

export default component.exports